<template>
  <a
    href="javascript:void(0)"
    class="link"
    @click.prevent="changeContent(thumb)"
  >
    <div class="thumb-box">
      <ul class="badge-list">
        <li class="left-top-area">
          <ul v-top-tag-list="tagList(thumb)"></ul>
        </li>
      </ul>
      <div v-if="image" class="picture-area">
        <WebpImage :imageInfo="{imageUrl: image, width: 407, height: 229, alt: alt, onImageLoad}" />
      </div>
      <div v-else class="no-thumb" :aria-hidden="!isImageLoaded">
        <span class="alt-text">{{ alt }}</span>
      </div>
    </div>
    <div class="sub-title">
      <div class="sub-right" v-title-list="{'titleList': titleList}">
      </div>
    </div>
  </a>
</template>

<script>
import _ from 'lodash'
import { commonTagList, titleList, topTagList } from '@/common/resources/directives'
import { PATH_NAME_PLAYER_STREAM } from '@/common/resources/router.const'
import WebpImage from '@/components/image/WebpImage'

export default {
  name: 'ThumbRelated',
  components: { WebpImage },
  directives: {
    titleList,
    topTagList,
    commonTagList
  },
  props: {
    thumb: {
      type: Object
    }
  },
  data () {
    return {
      isImageLoaded: false
    }
  },
  computed: {
    image () {
      return _.get(this.thumb, 'thumbnail', '')
    },
    alt () {
      return _.get(this.thumb, 'alt', '')
    },
    titleList () {
      return _.get(this.thumb, 'title_list', [])
    }
  },
  methods: {
    changeContent (thumb) {
      const { contentid = '', movieid = '' } = thumb
      const { path = '' } = this.$route
      const section = path.split('/').pop()
      const query = (section === 'vod')
        ? { contentid: contentid }
        : { movieid: movieid }

      this.$router.push({
        name: PATH_NAME_PLAYER_STREAM,
        params: { section: section },
        query: query
      })
    },
    tagList (thumb) {
      return _.get(thumb, 'top_taglist', []).concat(_.get(thumb, 'bottom_taglist', []))
    },
    onImageLoad () {
      this.isImageLoaded = true
    }
  }
}
</script>
